module.exports = __webpack_public_path__ + "static/img/assignments-placeholder.0558890.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/assignments-placeholder.jpg
// module id = 1704
// module chunks = 2